import { useEffect, useRef, useState } from 'react'
import { LockActivity } from '../../../../services/AnnualPlanService'
import { toast } from 'react-toastify'
import { Typography } from '@mui/material'
import { BannerModal } from '../../../customComponents/BannerModal'

interface Props {
  activityId: number
  activityName: string
  onClose: () => void
}

export const ActivityEditSession = (props: Props): JSX.Element => {
  const [isShowingExtendWarning, setIsShowingExtendWarning] = useState(false)

  const extendTimeoutId = useRef<NodeJS.Timeout | null>(null)
  const closeTimeoutId = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    startTimers()

    return () => {
      clearTimeout(extendTimeoutId.current as NodeJS.Timeout)
      clearTimeout(closeTimeoutId.current as NodeJS.Timeout)
    }
  }, [])

  const startTimers = (): void => {
    const timeoutId1 = setTimeout(() => {
      setIsShowingExtendWarning(true)
    }, 600000) // 10 minutes
    const timeoutId2 = setTimeout(() => {
      props.onClose()
    }, 900000) // 15 minutes
    extendTimeoutId.current = timeoutId1
    closeTimeoutId.current = timeoutId2
  }

  const handleConfirmExtendSession = async (): Promise<void> => {
    await LockActivity(props.activityId, props.activityName)

    clearTimeout(closeTimeoutId.current as NodeJS.Timeout)
    setIsShowingExtendWarning(false)
    toast.success('Session extended')

    startTimers()
  }

  return <>
    {isShowingExtendWarning &&
      <BannerModal
        title='Session Timeout'
        cancelButtonText='No'
        confirmButtonText='Yes'
        onClose={() => { setIsShowingExtendWarning(false) }}
        onConfirm={handleConfirmExtendSession}
        bodyContent={<Typography variant='body1'>You have 5 minutes left in your current edit session. Would you like to extend this? Failure to do so will result in loss of data.</Typography>}
      />
    }
  </>
}
